import { api } from './index';

const BASE_PATH = '/api/internal/attendances';

export type Attendance = {
  id: number;
  humanTime: string;
  humanDate: string;
  markedAt: Date;
  markedAtHasBeenUpdated: boolean;
}

export interface AttendanceForm {
  caregiverId: number;
  shiftId: number;
  markType: string;
  // check_in on a shift that already ended: also records its check_out
  finish?: boolean;
}

export interface AttendanceUpdateForm {
  markedAt: string;
  markedAtEditReason: string;
}

export const attendancesApi = {
  create(attendanceForm: AttendanceForm): Promise<Attendance> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { attendance: attendanceForm },
    }).then(response => response.data.attendance);
  },
  update(attendanceId: number, attendanceUpdateForm: AttendanceUpdateForm): Promise<boolean> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${attendanceId}`,
      data: { attendance: attendanceUpdateForm },
    });
  },
};
